import React, { useEffect, useState } from "react";
import { ALARM_FILTER, DEVICE_TYPES, getAlarmHeader, PAGE_PARENT } from "../../common/constant/common-constants";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { MonitorAlarmTable } from "../../components/Table/Alarm/MonitorAlarmTable";
import { VentilatorAlarmTable } from "../../components/Table/Alarm/VentilatorAlarmTable";
import DevicesTab from "../PatientRightPanel/MachineTabs/DevicesTab";
import "./AlarmHistoryContainer.scss";

function AlarmHistoryContainer(props) {
    const [header, setHeader] = useState(getAlarmHeader());
    const [ventilatorEventFilter, setVentilatorEventFilter] = useState({ name: null, label: 'All', id: 1 });
    const [monitorEventFilter, setMonitorEventFilter] = useState({ name: null, label: 'All', id: 1 });

    // useEffect(() => {
    //     setHeader(getAlarmHeader());
    // }, [props.activeVitalDevice])

    const handleEventFilterChange = (option) => {
        if (props.activeVitalDevice === DEVICE_TYPES.NOCCARC_PM_NX5) {
            setMonitorEventFilter(option)
        }
        if (props.activeVitalDevice === DEVICE_TYPES.VENTILATOR) {
            setVentilatorEventFilter(option)
        }
    }

    return (
        <div className="alarm-history-container">
            {props.activeVitalDevice === DEVICE_TYPES.NOCCARC_PM_NX5 &&
                <MonitorAlarmTable
                    bedId={props.bedId}
                    header={header}
                    PMAlarmData={props.alarmData}
                    filter={monitorEventFilter}
                    userView={props.userView}
                    monitorConnected={props.monitorConnected}
                />
            }
            {props.activeVitalDevice === DEVICE_TYPES.VENTILATOR &&
                <VentilatorAlarmTable
                    bedId={props.bedId}
                    header={header}
                    ventilatorAlarmData={props.ventilatorAlarmData}
                    filter={ventilatorEventFilter}
                    userView={props.userView}
                />
            }
        </div>
    );
}

export default AlarmHistoryContainer;